import { PropsWithChildren } from 'react';

import { ChakraFlex } from '@equip.health/ui';

export interface SectionProps extends PropsWithChildren {
  id: string;
}

export const Section = ({ children, id }: SectionProps) => (
  <ChakraFlex direction="column" gap="12px" id={id} width="100%">
    {children}
  </ChakraFlex>
);
